module.exports = __webpack_public_path__ + "img/oborudovanie-dlja-sklada.9dc31baa.svg";